import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { GeneralService } from '@app/@shared/services/general.service';

@Component({
  selector: 'app-select-ticket',
  templateUrl: './select-ticket.component.html',
  styleUrl: './select-ticket.component.scss',
})
export class SelectTicketComponent implements OnChanges {
  @Input() tickets: unknown[] = [];
  @Input() ticketSelected = 0;
  @Input() ticketValid: boolean[] = [];

  @Output() addTicket = new EventEmitter();
  @Output() selectTicket = new EventEmitter<number>();

  @Input() generalS?: GeneralService;
  @Input() pattern: string[] = [];

  letras: string[] = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tickets']) {
      this.tickets = changes['tickets'].currentValue;
      this.createLetterFromPattern();
    }
  }

  createLetterFromPattern() {
    if (this.pattern.length && this.generalS) {
      this.letras = this.generalS.generatePatternArray(this.tickets, this.pattern);
    }
  }

  get limitedTickets() {
    return this.tickets.slice(0, 26);
  }

  canAddMore(): boolean {
    return this.tickets.length < 26;
  }
}
